import { Link } from "react-router-dom";
import { Logo } from "../brand/Logo";
import { BRAND, NAV_LINKS } from "../../config/site";
import { ROUTES } from "../../config/routes";

const LEGAL = [
  { label: "Privacy Policy", to: ROUTES.PRIVACY, testId: "footer-link-privacy" },
  { label: "Terms & Conditions", to: ROUTES.TERMS, testId: "footer-link-terms" },
  { label: "Contact", to: ROUTES.CONTACT, testId: "footer-link-contact-legal" },
];

const FooterCol = ({ title, links }) => (
  <div>
    <h2 className="label-mono text-slate-500">{title}</h2>
    <ul className="mt-5 space-y-3">
      {links.map((l) => (
        <li key={l.testId}>
          <Link to={l.to} data-testid={l.testId} className="text-sm text-slate-400 transition-colors hover:text-slate-100 focus-ring rounded">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const SiteFooter = () => (
  <footer className="border-t border-white/10 bg-[#07080C]">
    <div className="container-x grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr]">
      <div data-testid="footer-brand" className="max-w-sm">
        <Logo testId="footer-logo" />
        <p className="mt-5 font-display text-lg font-semibold text-slate-100">{BRAND.tagline}</p>
        <p className="mt-2 text-sm text-slate-500">{BRAND.positioning}</p>
      </div>
      <FooterCol title="Navigate" links={NAV_LINKS.map((l) => ({ ...l, testId: `footer-${l.testId}` }))} />
      <FooterCol title="Legal" links={LEGAL} />
    </div>
    <div className="border-t border-white/5">
      <p data-testid="footer-copyright" className="container-x py-6 text-xs text-slate-500">
        © {new Date().getFullYear()} {BRAND.legalName}. All rights reserved.
      </p>
    </div>
  </footer>
);
